import { brand } from "@/mocks/site";

export default function StatsBar() {
  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto grid w-full max-w-content grid-cols-2 gap-x-6 gap-y-8 px-4 py-10 md:grid-cols-4 md:px-8">
        {brand.stats.map((stat) => (
          <div key={stat.label} className="text-center">
            <p className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">
              {stat.value}
            </p>
            <p className="mt-2 text-xs text-foreground-600 md:text-sm">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}